import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      '~libs.desktop.patient-prescription-history': {
         prescriptionConfidential: 'Recepta poufna',
         prescriptionHistory: 'Historia recept',
         table: {
            addToPrescription: 'Dodaj lek do eRecepty',
            dosage: 'Dawkowanie',
            extendedDosageTooltipTitle: 'Dawkowanie rozszerzone:',
            issuedFrom: 'Realizacja od',
            medicineName: 'Nazwa handlowa',
            noPrescriptionHistory: 'Brak historii recept',
            package: 'Opakowanie',
            prescriptionDate: 'Data recepty',
            quantity: 'L. opak.',
         },
      },
   },
};

export const translationKeys = createScopedTranslationKeys(
   translations.pl,
   '~libs.desktop.patient-prescription-history'
);
